import { authMiddlewareClient, updateShowAppBanner } from "@App/appReducer";
import FullPageLoader from "@Components/FullPageLoader";
import config from "@Config/index";
import { AppState } from "@Store/index";
import useWebViewEvents from "@Utils/webVewEventHandler";
import { setAppCookies } from "helpers/setCookie";
import useIsApp, { appOS } from "hooks/useIsApp";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const AppLayout = () => {
  const isApp = useIsApp();
  const dispatch = useDispatch();
  const { isUserDataFetching } = useSelector(({ appData }: AppState) => ({
    isUserDataFetching: appData.isUserDataFetching,
  }));
  useWebViewEvents();
  useEffect(() => {
    dispatch(updateShowAppBanner(false));
    if (isApp) {
      setAppCookies([
        {
          cname: "is_app",
          cvalue: "true",
          exdays: 7300,
          secure: true,
          domain: `.${config.WEB_SERVICE_HOST}`,
        },
        {
          cname: "app_type",
          cvalue: appOS,
          exdays: 7300,
          secure: true,
          domain: `.${config.WEB_SERVICE_HOST}`,
        },
      ]);
    } else if (!window.isApp) {
      setAppCookies([
        { cname: "is_app", cvalue: "false", exdays: -1, secure: true },
        { cname: "app_type", cvalue: "", exdays: -1, secure: true },
      ]);
    } else {
      setAppCookies([
        { cname: "is_app", cvalue: "false", exdays: -1, secure: true },
        { cname: "app_type", cvalue: "", exdays: -1, secure: true },
      ]);
    }
    if (window.localStorage.getItem("user_auth_token")) {
      dispatch(authMiddlewareClient());
    }
  }, []);

  if (isUserDataFetching)
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 1000,
          top: 0,
          left: 0,
          background: "#fff",
          width: "100%",
        }}
      >
        <FullPageLoader />
      </div>
    );

  return <></>;
};

export default AppLayout;
